import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { LayoutTemplate } from "lucide-react";
import PlusIcon from "../../../assets/icons/PlusIcon";
import Spinner from "../../../assets/icons/Spinner";
import Message from "../../../i18n/Message";
import ProjectTile from "./ProjectTile";
import { loadProjects } from "../store/builderActionCreators";
import { builderSelectors } from "../store/builderReducer";
import NewWorkspaceLayout from "../../workspace/layout/NewWorkspaceLayout";
import { linkToBuilderNewProject, linkToTemplates } from "../../../routes";

import "./ProjectListPage.scss";

const ProjectListPage = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const nav = useNavigate();
  const { workspaceId } = useParams();
  const projectList = useSelector(builderSelectors.getProjectList);
  const listCounter = useSelector(builderSelectors.getListCounter);

  useEffect(() => {
    if (workspaceId) {
      dispatch(loadProjects(intl, workspaceId));
    }
  }, [dispatch, intl, workspaceId, listCounter]);

  return (
    <NewWorkspaceLayout contentPanelClassName="project_list_page">
      <div className="breadcrumbs">&nbsp;</div>
      <h1>
        <Message id="app_builder_projects_title" />
      </h1>
      <div className="actions_panel">
        <button
          className="btn btn-outline-dark"
          onClick={() => nav(linkToBuilderNewProject(workspaceId))}
        >
          <PlusIcon size="18" color="#344767" />
          <Message id="new_builder_project" />
        </button>
        <button
          className="btn btn-outline-dark"
          onClick={() => nav(linkToTemplates(workspaceId))}
        >
          <LayoutTemplate size={18} color="#344767" />
          <Message id="start_with_template" />
        </button>
      </div>
      <div className="body_content">
        <div className="campaign_tiles">
          {!projectList && <Spinner />}
          {projectList && projectList.length === 0 && (
            <div className="empty_state">
              <Message id="no_builder_projects_yet" />
            </div>
          )}
          {projectList &&
            projectList.map((project) => (
              <ProjectTile key={project.uid} project={project} />
            ))}
        </div>
      </div>
    </NewWorkspaceLayout>
  );
};

export default ProjectListPage;
